<!--
If there's not enough space in the first row, create a separate label row. We mark this row as
aria-hidden because we don't want it to be read out as one of the weeks in the month.
-->
@if (_firstRowOffset < labelMinRequiredCells()) {
    <tr aria-hidden="true">
        <td
            class="ap-calendar-body-label"
            [attr.colspan]="numCols()"
            [style.paddingTop.%]="(50 * cellAspectRatio()) / numCols()"
            [style.paddingBottom.%]="(50 * cellAspectRatio()) / numCols()"
        >
            {{ label() }}
        </td>
    </tr>
}

<!-- Create the first row separately so we can include a special spacer cell. -->
@for (row of rows(); track row; let rowIndex = $index) {
    <tr>
        <!--
    We mark this cell as aria-hidden so it doesn't get read out as one of the days in the week.
    The aspect ratio of the table cells is maintained by setting the top and bottom padding as a
    percentage of the width (a variant of the trick described here:
    https://www.w3schools.com/howto/howto_css_aspect_ratio.asp).
    -->
        @if (rowIndex === 0 && _firstRowOffset) {
            <td
                aria-hidden="true"
                class="ap-calendar-body-label"
                [attr.colspan]="_firstRowOffset"
                [style.paddingTop.%]="(50 * cellAspectRatio()) / numCols()"
                [style.paddingBottom.%]="(50 * cellAspectRatio()) / numCols()"
            >
                {{ _firstRowOffset >= labelMinRequiredCells() ? label() : '' }}
            </td>
        }
        @for (item of row; track item; let colIndex = $index) {
            <td
                role="button"
                class="ap-calendar-body-cell"
                [tabindex]="_isActiveCell(rowIndex, colIndex) ? 0 : -1"
                [class.ap-calendar-body--disabled]="!item.enabled"
                [attr.aria-label]="item.ariaLabel"
                [attr.aria-disabled]="!item.enabled || null"
                (click)="_cellClicked(item)"
                [style.width.%]="100 / numCols()"
                [style.paddingTop.%]="(50 * cellAspectRatio()) / numCols()"
                [style.paddingBottom.%]="(50 * cellAspectRatio()) / numCols()"
            >
                <div
                    class="ap-calendar-body-cell-content"
                    [class.ap-calendar-body--active]="_isActiveCell(rowIndex, colIndex)"
                    [class.ap-calendar-body-selected]="selectedValue() === item.value"
                    [class.ap-calendar-body-today]="todayValue() === item.value"
                    [attr.data-testid]="item.value"
                >
                    {{ item.displayValue }}
                </div>
            </td>
        }
    </tr>
}
